import { put, call, takeLatest } from 'redux-saga/effects';

import AuthUtil from '../../AuthUtil';
import { PLAN_CATALOG } from '../../../components/global/Server/endpoints';
import { showErrorMessage } from '../../actions/global';
import { SERVER_FAILED_ERROR_MESSAGE } from '../../../pages/Dashboard/constants';
import {
  LOAD_PLAN_CATALOG,
  PUBLISH_PLAN_CATALOG,
  PREVIEW_PLAN_CATALOG,
  APPLY_PENDING_PLAN_CATALOG,
  SET_COMPANY_CUSTOM_RATE,
} from '../../constants/planCatalog';
import {
  storePlanCatalog,
  storePlanCatalogPreview,
  setPlanCatalogLoading,
  loadPlanCatalog,
} from '../../actions/planCatalog';
import { applyCatalog } from '../../../components/settings/ManageCompany/planCatalogRuntime';

function* loadPlanCatalogSaga(action) {
  try {
    yield put(setPlanCatalogLoading(true));
    const response = yield call(() =>
      AuthUtil.postRequest(PLAN_CATALOG.OVERVIEW, action.data || {})
    );
    if (response.status === 200 && response.data.success) {
      yield put(storePlanCatalog(response.data));
      // The wizard, the landing page and the Employee wizard all read the
      // rate card from wizardConfig's module state. Push the freshly loaded
      // catalog into it so those screens don't keep quoting the version this
      // one is editing away from.
      applyCatalog(response.data.catalog);
    } else {
      yield put(setPlanCatalogLoading(false));
      yield put(
        showErrorMessage(response.data?.message || SERVER_FAILED_ERROR_MESSAGE)
      );
    }
  } catch (error) {
    yield put(setPlanCatalogLoading(false));
    yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
  }
}

function* previewPlanCatalogSaga(action) {
  try {
    const response = yield call(() =>
      AuthUtil.postRequest(PLAN_CATALOG.PREVIEW_CHANGES, action.data)
    );
    const ok = response.status === 200 && response.data.success;
    if (ok) {
      yield put(storePlanCatalogPreview(response.data));
    } else {
      yield put(
        showErrorMessage(response.data?.message || SERVER_FAILED_ERROR_MESSAGE)
      );
    }
    if (action.callback) action.callback(ok, response.data);
  } catch (error) {
    yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    if (action.callback) action.callback(false, null);
  }
}

function* publishPlanCatalogSaga(action) {
  try {
    const response = yield call(() =>
      AuthUtil.postRequest(PLAN_CATALOG.PUBLISH, action.data)
    );
    const ok = response.status === 200 && response.data.success;
    if (ok) {
      if (response.data.catalog) applyCatalog(response.data.catalog);
      // Re-read rather than trusting the publish response: the roll-out it
      // just performed changes the per-company counts and the queue this
      // screen reports on.
      yield put(loadPlanCatalog({}));
    } else {
      yield put(
        showErrorMessage(response.data?.message || SERVER_FAILED_ERROR_MESSAGE)
      );
    }
    if (action.callback) action.callback(ok, response.data);
  } catch (error) {
    yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    if (action.callback) action.callback(false, null);
  }
}

function* applyPendingPlanCatalogSaga(action) {
  try {
    const response = yield call(() =>
      AuthUtil.postRequest(PLAN_CATALOG.APPLY_PENDING_NOW, action.data || {})
    );
    const ok = response.status === 200 && response.data.success;
    if (ok) {
      yield put(loadPlanCatalog({}));
    } else {
      yield put(
        showErrorMessage(response.data?.message || SERVER_FAILED_ERROR_MESSAGE)
      );
    }
    if (action.callback) action.callback(ok, response.data);
  } catch (error) {
    yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    if (action.callback) action.callback(false, null);
  }
}

function* setCompanyCustomRateSaga(action) {
  try {
    const response = yield call(() =>
      AuthUtil.postRequest(PLAN_CATALOG.SET_CUSTOM_RATE, action.data)
    );
    const ok = response.status === 200 && response.data.success;
    if (ok) {
      yield put(loadPlanCatalog({}));
    } else {
      yield put(
        showErrorMessage(response.data?.message || SERVER_FAILED_ERROR_MESSAGE)
      );
    }
    if (action.callback) action.callback(ok, response.data);
  } catch (error) {
    yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    if (action.callback) action.callback(false, null);
  }
}

export default function* planCatalogSagas() {
  yield takeLatest(LOAD_PLAN_CATALOG, loadPlanCatalogSaga);
  yield takeLatest(PREVIEW_PLAN_CATALOG, previewPlanCatalogSaga);
  yield takeLatest(PUBLISH_PLAN_CATALOG, publishPlanCatalogSaga);
  yield takeLatest(APPLY_PENDING_PLAN_CATALOG, applyPendingPlanCatalogSaga);
  yield takeLatest(SET_COMPANY_CUSTOM_RATE, setCompanyCustomRateSaga);
}
